module.exports = __webpack_public_path__ + "static/ume02-f22eaf16c79fecf8ebf6e7d4090f66a9.png";